import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { SocialUser } from '@abacritt/angularx-social-login';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private userService: UserService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.userService.getUser()).pipe(mergeMap((user: SocialUser | null) => {
      if (!user) {
        this.userService.signOutAndRedirect();
        return throwError(() => new Error('No authenticated user'));
      }

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user.idToken}`
        }
      });

      return next.handle(request);
    }));
  }
}
